import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { fetchAllUsersQLT } from '../../../api/userQLT';
import AdminContext from '../../../_helper/Admin';
import UserQLTStats from './UserQLTStats';
import UserQLTTable from './UserQLTTable';
import UserQLTChart from './UserQLTChart';
import UserQLTDistribution from './UserQLTDistribution';
import UserQLTActivities from './UserQLTActivities';

const OnlineCourse = () => {
  const [usersQLT, setUsersQLT] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, status } = useContext(AdminContext);

  const loadData = async () => {
    if (!isAuthenticated || status !== 'LOGGED_IN') {
      setUsersQLT([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await fetchAllUsersQLT();
      const users = Array.isArray(response) ? response : response?.data || [];
      setUsersQLT(users);
    } catch (error) {
      console.error('Error loading users QLT:', error);
      setUsersQLT([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [isAuthenticated, status]);

  return (
    <Fragment>
      <Breadcrumbs mainTitle='Quản Lý User QLT' parent='Dashboard' title='User QLT' />
      <Container fluid={true}>
        <Row>
          <UserQLTStats usersQLT={usersQLT} loading={loading} />
          <UserQLTChart usersQLT={usersQLT} loading={loading} />
          <UserQLTDistribution usersQLT={usersQLT} loading={loading} />
          <UserQLTActivities usersQLT={usersQLT} loading={loading} />
          <UserQLTTable usersQLT={usersQLT} loading={loading} onRefresh={loadData} />
        </Row>
      </Container>
    </Fragment>
  );
};

export default OnlineCourse;
